"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderLoader = exports.renderComponent = void 0;
var React = require("react");
var webexUI_1 = require("webexUI");
var ModalDialog_1 = require("Views/Partials/Components/ModalDialog");
var SignUpFormStatusMessage_1 = require("Views/Partials/Components/SignUp/components/SignUpFormStatusMessage");
var Newsletter_1 = require("./components/Newsletter");
exports.renderComponent = {
    Form: function (signUpTypes, apiUrl, hashMapTypes, reCaptchaSiteKey, bypassRecaptchaKey, render, control, pageId) {
        return React.createElement(Newsletter_1.NewsletterForm, { items: signUpTypes.formItems, inputObject: signUpTypes.inputObject, pageId: pageId, apiUrl: apiUrl, renderSpinner: render.renderSpinner, renderMessage: render.renderMessage, control: control, additionalFormData: hashMapTypes.additionalFormData, reCaptchaSiteKey: reCaptchaSiteKey, bypassRecaptchaKey: bypassRecaptchaKey });
    },
    Message: function (message, buttonLabel) { return (React.createElement(SignUpFormStatusMessage_1.SignUpFormStatusMessage, { message: message, buttonLabel: buttonLabel, close: close })); },
    Spinner: React.createElement(webexUI_1.Spinner, { visible: true }),
};
var renderLoader = function (component, selector, title, classes, popupAriaLabel, closeButtonAriaLabel, onModalClose) {
    var additionalModalParameters = {
        classes: classes,
        onModalClose: onModalClose,
        popupAriaLabel: popupAriaLabel,
        closeButtonAriaLabel: closeButtonAriaLabel,
        backdrop: 'static',
    };
    ModalDialog_1.RenderModal(component, selector, title, additionalModalParameters);
};
exports.renderLoader = renderLoader;
